import * as React from "react"
import Svg, { G, Circle, Path } from "react-native-svg"

function BlueCircleTrashSvg(props) {
	return (
		<Svg width={35} height={35} viewBox="0 0 35 35" {...props}>
			<G data-name="Group 1244">
				<G data-name="Group 1027">
					<Circle
						data-name="Ellipse 2"
						cx={17.5}
						cy={17.5}
						r={17.5}
						transform="rotate(-90 17.5 17.5)"
						fill="#0065db"
					/>
				</G>
				<Path
					data-name="Path 486"
					d="M11.888 23.225a1.781 1.781 0 001.776 1.776h7.1a1.781 1.781 0 001.776-1.776V12.57H11.888zm2.184-6.321l1.252-1.253 1.891 1.882 1.885-1.882 1.252 1.252-1.882 1.882 1.882 1.882-1.252 1.252-1.882-1.882-1.885 1.882-1.252-1.251 1.882-1.882zm6.25-7l-.887-.885H15l-.888.888H11v1.776h12.43V9.907z"
					fill="#fff"
				/>
			</G>
		</Svg>
	)
}

export default BlueCircleTrashSvg
